import { AfterViewInit, Directive, ElementRef, HostBinding, HostListener, inject } from '@angular/core';
import { Nullable } from 'primeng/ts-helpers';

@Directive({
  standalone: true,
  selector: 'p-button[ospButtonFocusHandler]',
})
export class ButtonFocusHandlerDirective implements AfterViewInit {
  private hostElementRef = inject(ElementRef);
  private nativeButtonElementRef: ElementRef | Nullable = null;

  @HostBinding('tabindex') tabindex = -1;

  @HostListener('focus') hostFocus(): void {
    this.nativeButtonElementRef?.nativeElement?.focus();
  }

  ngAfterViewInit(): void {
    this.nativeButtonElementRef = this.hostElementRef.nativeElement.querySelector('button');
  }

}
